import React from 'react';
import {Box} from "grommet";

// <div className='tableauPlaceholder' id='viz1611892756213' style='position: relative'>
//     <noscript><a href='#'><img alt=' '
//                                src='https:&#47;&#47;public.tableau.com&#47;static&#47;images&#47;GD&#47;GDSP_CDEv1_0&#47;ChinaDebtExposure&#47;1_rss.png'
//                                style='border: none'/></a></noscript>
//     <object className='tableauViz' style='display:none;'>
//         <param name='host_url' value='https%3A%2F%2Fpublic.tableau.com%2F'/>
//         <param name='embed_code_version' value='3'/>
//         <param name='site_root' value=''/>
//         <param name='name' value='GDSP_CDEv1_0&#47;ChinaDebtExposure'/>
//         <param name='tabs' value='no'/>
//         <param name='toolbar' value='yes'/>
//         <param name='static_image'
//                value='https:&#47;&#47;public.tableau.com&#47;static&#47;images&#47;GD&#47;GDSP_CDEv1_0&#47;ChinaDebtExposure&#47;1.png'/>
//         <param name='animate_transition' value='yes'/>
//         <param name='display_static_image' value='yes'/>
//         <param name='display_spinner' value='yes'/>
//         <param name='display_overlay' value='yes'/>
//         <param name='display_count' value='yes'/>
//         <param name='language' value='en'/>
//         <param name='filter' value='publish=yes'/>
//     </object>
// </div>
// <script
//     type='text/javascript'>                    var divElement = document.getElementById('viz1611892756213'); var vizElement = divElement.getElementsByTagName('object')[0]; if ( divElement.offsetWidth > 800 ) {vizElement.style.width = '1101px';vizElement.style.height='823px';} else if ( divElement.offsetWidth > 500 ) {vizElement.style.width = '1101px';vizElement.style.height='823px';} else {vizElement.style.width = '100%';vizElement.style.height='1177px';} var scriptElement = document.createElement('script'); scriptElement.src = 'https://public.tableau.com/javascripts/api/viz_v1.js'; vizElement.parentNode.insertBefore(scriptElement, vizElement
// )
// ;                </script>


const vizString = 'viz1611807432599';
const paramName = "GDSP_CDEv1_0&#47;ChinaDebtExposure";


const paramName2 = paramName.replaceAll("#47;", "/");
const vizName = 'GF&#47;' + paramName + '&#47;1';
const urlString1 = "'https:&#47;&#47;public.tableau.com&#47;static&#47;images&#47;" + vizName + ".png'";
const urlString2 = "'https:&#47;&#47;public.tableau.com&#47;static&#47;images&#47;" + vizName + "_rss.png'";
const PISH = () => { return <param name='name' value={paramName2}/> };

export default class TableauCDEHolder extends React.Component {
    constructor() {
        super();
        this.state = {
            loading : true
        };

    }
    componentDidMount() {
        // document.body.addEventListener("", function (event){
        //
        // });
        const scriptTag = document.createElement("script");
        scriptTag.innerHTML =
            "var divElement = document.getElementById('" + vizString + "');" +
            "console.log('test');" +
            "var vizElement = divElement.getElementsByTagName('object')[0];" +
            "if ( divElement.offsetWidth > 800 ) {vizElement.style.width = '1101px';vizElement.style.height='823px';} else if ( divElement.offsetWidth > 500 ) {vizElement.style.width = '1101px';vizElement.style.height='823px';} else {vizElement.style.width = '100%';vizElement.style.height='1177px';}" +
            "var scriptElement = document.createElement('script');" +
            "scriptElement.src = 'https://public.tableau.com/javascripts/api/viz_v1.js';" +
            "vizElement.parentNode.insertBefore(scriptElement, vizElement);" +
            "console.log(vizElement);";
        scriptTag.async = true;
        document.body.appendChild(scriptTag);
    }

    render() {
        return (
            <React.Fragment>
                <Box
                    direction="row"
                    justify="center"
                >
                <div className='tableauPlaceholder' id={vizString} style={{position: "relative"}}>
                    <noscript><a href='#'><img alt=' '
                                               src={urlString2}
                                               style={{border: "none"}}/></a></noscript>
                    <object className='tableauViz' style={{display: "none"}}>
                        <param name='host_url' value='https%3A%2F%2Fpublic.tableau.com%2F'/>
                        <param name='embed_code_version' value='3'/>
                        <param name='site_root' value=''/>
                        <PISH/>
                        <param name='tabs' value='no'/>
                        <param name='toolbar' value='yes'/>
                        <param name='static_image'
                               value={urlString1}/>
                        <param name='animate_transition' value='yes'/>
                        <param name='display_static_image' value='yes'/>
                        <param name='display_spinner' value='yes'/>
                        <param name='display_overlay' value='yes'/>
                        <param name='display_count' value='yes'/>
                        <param name='language' value='en'/>
                        <param name='filter' value='publish=yes'/>
                    </object>
                </div>
                </Box>
            </React.Fragment>
        );
    }
}
